import type { Resource, ResourceKey } from 'i18next';

import type { TRANSLATION_NAMESPACES } from '../../features/i18n/constants';

import de_activity from './de/activity.json';
import de_asset from './de/asset.json';
import de_assignment from './de/assignment.json';
import de_checklist from './de/checklist.json';
import de_conditions from './de/conditions.json';
import de_configuration from './de/configuration.json';
import de_documents from './de/documents.json';
import de_ErrorView from './de/ErrorView.json';
import de_file_viewer from './de/file-viewer.json';
import de_FileUploader from './de/FileUploader.json';
import de_infobar from './de/infobar.json';
import de_LandingPage from './de/LandingPage.json';
import de_main_topbar from './de/main-topbar.json';
import de_measurement from './de/measurement.json';
import de_media_manager from './de/media-manager.json';
import de_notification from './de/notification.json';
import de_observations from './de/observations.json';
import de_search from './de/search.json';
import de_sidebar from './de/sidebar.json';
import de_template from './de/template.json';
import de_ThreeD from './de/ThreeD.json';
import de_timeseries from './de/timeseries.json';
import de_trends from './de/trends.json';
import de_user_onboarding from './de/user-onboarding.json';
import de_user from './de/user.json';
import en_activity from './en/activity.json';
import en_asset from './en/asset.json';
import en_assignment from './en/assignment.json';
import en_checklist from './en/checklist.json';
import en_conditions from './en/conditions.json';
import en_configuration from './en/configuration.json';
import en_documents from './en/documents.json';
import en_ErrorView from './en/ErrorView.json';
import en_file_viewer from './en/file-viewer.json';
import en_FileUploader from './en/FileUploader.json';
import en_infobar from './en/infobar.json';
import en_LandingPage from './en/LandingPage.json';
import en_main_topbar from './en/main-topbar.json';
import en_measurement from './en/measurement.json';
import en_media_manager from './en/media-manager.json';
import en_notification from './en/notification.json';
import en_observations from './en/observations.json';
import en_search from './en/search.json';
import en_sidebar from './en/sidebar.json';
import en_template from './en/template.json';
import en_ThreeD from './en/ThreeD.json';
import en_timeseries from './en/timeseries.json';
import en_trends from './en/trends.json';
import en_user_onboarding from './en/user-onboarding.json';
import en_user from './en/user.json';
import es_activity from './es/activity.json';
import es_asset from './es/asset.json';
import es_assignment from './es/assignment.json';
import es_checklist from './es/checklist.json';
import es_conditions from './es/conditions.json';
import es_configuration from './es/configuration.json';
import es_documents from './es/documents.json';
import es_ErrorView from './es/ErrorView.json';
import es_file_viewer from './es/file-viewer.json';
import es_FileUploader from './es/FileUploader.json';
import es_infobar from './es/infobar.json';
import es_LandingPage from './es/LandingPage.json';
import es_main_topbar from './es/main-topbar.json';
import es_measurement from './es/measurement.json';
import es_media_manager from './es/media-manager.json';
import es_notification from './es/notification.json';
import es_observations from './es/observations.json';
import es_search from './es/search.json';
import es_sidebar from './es/sidebar.json';
import es_template from './es/template.json';
import es_ThreeD from './es/ThreeD.json';
import es_timeseries from './es/timeseries.json';
import es_trends from './es/trends.json';
import es_user_onboarding from './es/user-onboarding.json';
import es_user from './es/user.json';
import fr_activity from './fr/activity.json';
import fr_asset from './fr/asset.json';
import fr_assignment from './fr/assignment.json';
import fr_checklist from './fr/checklist.json';
import fr_conditions from './fr/conditions.json';
import fr_configuration from './fr/configuration.json';
import fr_documents from './fr/documents.json';
import fr_ErrorView from './fr/ErrorView.json';
import fr_file_viewer from './fr/file-viewer.json';
import fr_FileUploader from './fr/FileUploader.json';
import fr_infobar from './fr/infobar.json';
import fr_LandingPage from './fr/LandingPage.json';
import fr_main_topbar from './fr/main-topbar.json';
import fr_measurement from './fr/measurement.json';
import fr_media_manager from './fr/media-manager.json';
import fr_notification from './fr/notification.json';
import fr_observations from './fr/observations.json';
import fr_search from './fr/search.json';
import fr_sidebar from './fr/sidebar.json';
import fr_template from './fr/template.json';
import fr_ThreeD from './fr/ThreeD.json';
import fr_timeseries from './fr/timeseries.json';
import fr_trends from './fr/trends.json';
import fr_user_onboarding from './fr/user-onboarding.json';
import fr_user from './fr/user.json';
import it_activity from './it/activity.json';
import it_asset from './it/asset.json';
import it_assignment from './it/assignment.json';
import it_checklist from './it/checklist.json';
import it_conditions from './it/conditions.json';
import it_configuration from './it/configuration.json';
import it_documents from './it/documents.json';
import it_ErrorView from './it/ErrorView.json';
import it_file_viewer from './it/file-viewer.json';
import it_FileUploader from './it/FileUploader.json';
import it_infobar from './it/infobar.json';
import it_LandingPage from './it/LandingPage.json';
import it_main_topbar from './it/main-topbar.json';
import it_measurement from './it/measurement.json';
import it_media_manager from './it/media-manager.json';
import it_notification from './it/notification.json';
import it_observations from './it/observations.json';
import it_search from './it/search.json';
import it_sidebar from './it/sidebar.json';
import it_template from './it/template.json';
import it_ThreeD from './it/ThreeD.json';
import it_timeseries from './it/timeseries.json';
import it_trends from './it/trends.json';
import it_user_onboarding from './it/user-onboarding.json';
import it_user from './it/user.json';
import ja_activity from './ja/activity.json';
import ja_asset from './ja/asset.json';
import ja_assignment from './ja/assignment.json';
import ja_checklist from './ja/checklist.json';
import ja_conditions from './ja/conditions.json';
import ja_configuration from './ja/configuration.json';
import ja_documents from './ja/documents.json';
import ja_ErrorView from './ja/ErrorView.json';
import ja_file_viewer from './ja/file-viewer.json';
import ja_FileUploader from './ja/FileUploader.json';
import ja_infobar from './ja/infobar.json';
import ja_LandingPage from './ja/LandingPage.json';
import ja_main_topbar from './ja/main-topbar.json';
import ja_measurement from './ja/measurement.json';
import ja_media_manager from './ja/media-manager.json';
import ja_notification from './ja/notification.json';
import ja_observations from './ja/observations.json';
import ja_search from './ja/search.json';
import ja_sidebar from './ja/sidebar.json';
import ja_template from './ja/template.json';
import ja_ThreeD from './ja/ThreeD.json';
import ja_timeseries from './ja/timeseries.json';
import ja_trends from './ja/trends.json';
import ja_user_onboarding from './ja/user-onboarding.json';
import ja_user from './ja/user.json';
import ko_activity from './ko/activity.json';
import ko_asset from './ko/asset.json';
import ko_assignment from './ko/assignment.json';
import ko_checklist from './ko/checklist.json';
import ko_conditions from './ko/conditions.json';
import ko_configuration from './ko/configuration.json';
import ko_documents from './ko/documents.json';
import ko_ErrorView from './ko/ErrorView.json';
import ko_file_viewer from './ko/file-viewer.json';
import ko_FileUploader from './ko/FileUploader.json';
import ko_infobar from './ko/infobar.json';
import ko_LandingPage from './ko/LandingPage.json';
import ko_main_topbar from './ko/main-topbar.json';
import ko_measurement from './ko/measurement.json';
import ko_media_manager from './ko/media-manager.json';
import ko_notification from './ko/notification.json';
import ko_observations from './ko/observations.json';
import ko_search from './ko/search.json';
import ko_sidebar from './ko/sidebar.json';
import ko_template from './ko/template.json';
import ko_ThreeD from './ko/ThreeD.json';
import ko_timeseries from './ko/timeseries.json';
import ko_trends from './ko/trends.json';
import ko_user_onboarding from './ko/user-onboarding.json';
import ko_user from './ko/user.json';
import lv_activity from './lv/activity.json';
import lv_asset from './lv/asset.json';
import lv_assignment from './lv/assignment.json';
import lv_checklist from './lv/checklist.json';
import lv_conditions from './lv/conditions.json';
import lv_configuration from './lv/configuration.json';
import lv_documents from './lv/documents.json';
import lv_ErrorView from './lv/ErrorView.json';
import lv_file_viewer from './lv/file-viewer.json';
import lv_FileUploader from './lv/FileUploader.json';
import lv_infobar from './lv/infobar.json';
import lv_LandingPage from './lv/LandingPage.json';
import lv_main_topbar from './lv/main-topbar.json';
import lv_measurement from './lv/measurement.json';
import lv_media_manager from './lv/media-manager.json';
import lv_notification from './lv/notification.json';
import lv_observations from './lv/observations.json';
import lv_search from './lv/search.json';
import lv_sidebar from './lv/sidebar.json';
import lv_template from './lv/template.json';
import lv_ThreeD from './lv/ThreeD.json';
import lv_timeseries from './lv/timeseries.json';
import lv_trends from './lv/trends.json';
import lv_user_onboarding from './lv/user-onboarding.json';
import lv_user from './lv/user.json';
import nb_activity from './nb/activity.json';
import nb_asset from './nb/asset.json';
import nb_assignment from './nb/assignment.json';
import nb_checklist from './nb/checklist.json';
import nb_conditions from './nb/conditions.json';
import nb_configuration from './nb/configuration.json';
import nb_documents from './nb/documents.json';
import nb_ErrorView from './nb/ErrorView.json';
import nb_file_viewer from './nb/file-viewer.json';
import nb_FileUploader from './nb/FileUploader.json';
import nb_infobar from './nb/infobar.json';
import nb_LandingPage from './nb/LandingPage.json';
import nb_main_topbar from './nb/main-topbar.json';
import nb_measurement from './nb/measurement.json';
import nb_media_manager from './nb/media-manager.json';
import nb_notification from './nb/notification.json';
import nb_observations from './nb/observations.json';
import nb_search from './nb/search.json';
import nb_sidebar from './nb/sidebar.json';
import nb_template from './nb/template.json';
import nb_ThreeD from './nb/ThreeD.json';
import nb_timeseries from './nb/timeseries.json';
import nb_trends from './nb/trends.json';
import nb_user_onboarding from './nb/user-onboarding.json';
import nb_user from './nb/user.json';
import nl_activity from './nl/activity.json';
import nl_asset from './nl/asset.json';
import nl_assignment from './nl/assignment.json';
import nl_checklist from './nl/checklist.json';
import nl_conditions from './nl/conditions.json';
import nl_configuration from './nl/configuration.json';
import nl_documents from './nl/documents.json';
import nl_ErrorView from './nl/ErrorView.json';
import nl_file_viewer from './nl/file-viewer.json';
import nl_FileUploader from './nl/FileUploader.json';
import nl_infobar from './nl/infobar.json';
import nl_LandingPage from './nl/LandingPage.json';
import nl_main_topbar from './nl/main-topbar.json';
import nl_measurement from './nl/measurement.json';
import nl_media_manager from './nl/media-manager.json';
import nl_notification from './nl/notification.json';
import nl_observations from './nl/observations.json';
import nl_search from './nl/search.json';
import nl_sidebar from './nl/sidebar.json';
import nl_template from './nl/template.json';
import nl_ThreeD from './nl/ThreeD.json';
import nl_timeseries from './nl/timeseries.json';
import nl_trends from './nl/trends.json';
import nl_user_onboarding from './nl/user-onboarding.json';
import nl_user from './nl/user.json';
import pt_activity from './pt/activity.json';
import pt_asset from './pt/asset.json';
import pt_assignment from './pt/assignment.json';
import pt_checklist from './pt/checklist.json';
import pt_conditions from './pt/conditions.json';
import pt_configuration from './pt/configuration.json';
import pt_documents from './pt/documents.json';
import pt_ErrorView from './pt/ErrorView.json';
import pt_file_viewer from './pt/file-viewer.json';
import pt_FileUploader from './pt/FileUploader.json';
import pt_infobar from './pt/infobar.json';
import pt_LandingPage from './pt/LandingPage.json';
import pt_main_topbar from './pt/main-topbar.json';
import pt_measurement from './pt/measurement.json';
import pt_media_manager from './pt/media-manager.json';
import pt_notification from './pt/notification.json';
import pt_observations from './pt/observations.json';
import pt_search from './pt/search.json';
import pt_sidebar from './pt/sidebar.json';
import pt_template from './pt/template.json';
import pt_ThreeD from './pt/ThreeD.json';
import pt_timeseries from './pt/timeseries.json';
import pt_trends from './pt/trends.json';
import pt_user_onboarding from './pt/user-onboarding.json';
import pt_user from './pt/user.json';
import sv_activity from './sv/activity.json';
import sv_asset from './sv/asset.json';
import sv_assignment from './sv/assignment.json';
import sv_checklist from './sv/checklist.json';
import sv_conditions from './sv/conditions.json';
import sv_configuration from './sv/configuration.json';
import sv_documents from './sv/documents.json';
import sv_ErrorView from './sv/ErrorView.json';
import sv_file_viewer from './sv/file-viewer.json';
import sv_FileUploader from './sv/FileUploader.json';
import sv_infobar from './sv/infobar.json';
import sv_LandingPage from './sv/LandingPage.json';
import sv_main_topbar from './sv/main-topbar.json';
import sv_measurement from './sv/measurement.json';
import sv_media_manager from './sv/media-manager.json';
import sv_notification from './sv/notification.json';
import sv_observations from './sv/observations.json';
import sv_search from './sv/search.json';
import sv_sidebar from './sv/sidebar.json';
import sv_template from './sv/template.json';
import sv_ThreeD from './sv/ThreeD.json';
import sv_timeseries from './sv/timeseries.json';
import sv_trends from './sv/trends.json';
import sv_user_onboarding from './sv/user-onboarding.json';
import sv_user from './sv/user.json';
import zh_activity from './zh/activity.json';
import zh_asset from './zh/asset.json';
import zh_assignment from './zh/assignment.json';
import zh_checklist from './zh/checklist.json';
import zh_conditions from './zh/conditions.json';
import zh_configuration from './zh/configuration.json';
import zh_documents from './zh/documents.json';
import zh_ErrorView from './zh/ErrorView.json';
import zh_file_viewer from './zh/file-viewer.json';
import zh_FileUploader from './zh/FileUploader.json';
import zh_infobar from './zh/infobar.json';
import zh_LandingPage from './zh/LandingPage.json';
import zh_main_topbar from './zh/main-topbar.json';
import zh_measurement from './zh/measurement.json';
import zh_media_manager from './zh/media-manager.json';
import zh_notification from './zh/notification.json';
import zh_observations from './zh/observations.json';
import zh_search from './zh/search.json';
import zh_sidebar from './zh/sidebar.json';
import zh_template from './zh/template.json';
import zh_ThreeD from './zh/ThreeD.json';
import zh_timeseries from './zh/timeseries.json';
import zh_trends from './zh/trends.json';
import zh_user_onboarding from './zh/user-onboarding.json';
import zh_user from './zh/user.json';

/**
 * Bundled Infield translations: one JSON file per i18next namespace per locale
 * (`./<locale>/<file>.json`). Each import targets a file; the object keys below
 * are the namespace IDs (matches `TRANSLATION_NAMESPACES` / filenames). Every
 * locale repeats the same set of keys — one file per namespace per language.
 *
 * EN is the source locale; others come from Phrase pull.
 *
 * Use default JSON imports (not `import * as`): parsed JSON is frozen;
 * `I18nWrapper` / `addResourceBundle` must merge into plain objects.
 */
type NamespaceMap = Record<
  (typeof TRANSLATION_NAMESPACES)[keyof typeof TRANSLATION_NAMESPACES],
  ResourceKey
>;

const deFilesByNamespace: NamespaceMap = {
  activity: de_activity,
  asset: de_asset,
  assignment: de_assignment,
  checklist: de_checklist,
  conditions: de_conditions,
  configuration: de_configuration,
  documents: de_documents,
  ErrorView: de_ErrorView,
  'file-viewer': de_file_viewer,
  FileUploader: de_FileUploader,
  infobar: de_infobar,
  LandingPage: de_LandingPage,
  'main-topbar': de_main_topbar,
  measurement: de_measurement,
  'media-manager': de_media_manager,
  notification: de_notification,
  observations: de_observations,
  search: de_search,
  sidebar: de_sidebar,
  template: de_template,
  ThreeD: de_ThreeD,
  timeseries: de_timeseries,
  trends: de_trends,
  'user-onboarding': de_user_onboarding,
  user: de_user,
};

const enFilesByNamespace: NamespaceMap = {
  activity: en_activity,
  asset: en_asset,
  assignment: en_assignment,
  checklist: en_checklist,
  conditions: en_conditions,
  configuration: en_configuration,
  documents: en_documents,
  ErrorView: en_ErrorView,
  'file-viewer': en_file_viewer,
  FileUploader: en_FileUploader,
  infobar: en_infobar,
  LandingPage: en_LandingPage,
  'main-topbar': en_main_topbar,
  measurement: en_measurement,
  'media-manager': en_media_manager,
  notification: en_notification,
  observations: en_observations,
  search: en_search,
  sidebar: en_sidebar,
  template: en_template,
  ThreeD: en_ThreeD,
  timeseries: en_timeseries,
  trends: en_trends,
  'user-onboarding': en_user_onboarding,
  user: en_user,
};

const esFilesByNamespace: NamespaceMap = {
  activity: es_activity,
  asset: es_asset,
  assignment: es_assignment,
  checklist: es_checklist,
  conditions: es_conditions,
  configuration: es_configuration,
  documents: es_documents,
  ErrorView: es_ErrorView,
  'file-viewer': es_file_viewer,
  FileUploader: es_FileUploader,
  infobar: es_infobar,
  LandingPage: es_LandingPage,
  'main-topbar': es_main_topbar,
  measurement: es_measurement,
  'media-manager': es_media_manager,
  notification: es_notification,
  observations: es_observations,
  search: es_search,
  sidebar: es_sidebar,
  template: es_template,
  ThreeD: es_ThreeD,
  timeseries: es_timeseries,
  trends: es_trends,
  'user-onboarding': es_user_onboarding,
  user: es_user,
};

const frFilesByNamespace: NamespaceMap = {
  activity: fr_activity,
  asset: fr_asset,
  assignment: fr_assignment,
  checklist: fr_checklist,
  conditions: fr_conditions,
  configuration: fr_configuration,
  documents: fr_documents,
  ErrorView: fr_ErrorView,
  'file-viewer': fr_file_viewer,
  FileUploader: fr_FileUploader,
  infobar: fr_infobar,
  LandingPage: fr_LandingPage,
  'main-topbar': fr_main_topbar,
  measurement: fr_measurement,
  'media-manager': fr_media_manager,
  notification: fr_notification,
  observations: fr_observations,
  search: fr_search,
  sidebar: fr_sidebar,
  template: fr_template,
  ThreeD: fr_ThreeD,
  timeseries: fr_timeseries,
  trends: fr_trends,
  'user-onboarding': fr_user_onboarding,
  user: fr_user,
};

const itFilesByNamespace: NamespaceMap = {
  activity: it_activity,
  asset: it_asset,
  assignment: it_assignment,
  checklist: it_checklist,
  conditions: it_conditions,
  configuration: it_configuration,
  documents: it_documents,
  ErrorView: it_ErrorView,
  'file-viewer': it_file_viewer,
  FileUploader: it_FileUploader,
  infobar: it_infobar,
  LandingPage: it_LandingPage,
  'main-topbar': it_main_topbar,
  measurement: it_measurement,
  'media-manager': it_media_manager,
  notification: it_notification,
  observations: it_observations,
  search: it_search,
  sidebar: it_sidebar,
  template: it_template,
  ThreeD: it_ThreeD,
  timeseries: it_timeseries,
  trends: it_trends,
  'user-onboarding': it_user_onboarding,
  user: it_user,
};

const jaFilesByNamespace: NamespaceMap = {
  activity: ja_activity,
  asset: ja_asset,
  assignment: ja_assignment,
  checklist: ja_checklist,
  conditions: ja_conditions,
  configuration: ja_configuration,
  documents: ja_documents,
  ErrorView: ja_ErrorView,
  'file-viewer': ja_file_viewer,
  FileUploader: ja_FileUploader,
  infobar: ja_infobar,
  LandingPage: ja_LandingPage,
  'main-topbar': ja_main_topbar,
  measurement: ja_measurement,
  'media-manager': ja_media_manager,
  notification: ja_notification,
  observations: ja_observations,
  search: ja_search,
  sidebar: ja_sidebar,
  template: ja_template,
  ThreeD: ja_ThreeD,
  timeseries: ja_timeseries,
  trends: ja_trends,
  'user-onboarding': ja_user_onboarding,
  user: ja_user,
};

const koFilesByNamespace: NamespaceMap = {
  activity: ko_activity,
  asset: ko_asset,
  assignment: ko_assignment,
  checklist: ko_checklist,
  conditions: ko_conditions,
  configuration: ko_configuration,
  documents: ko_documents,
  ErrorView: ko_ErrorView,
  'file-viewer': ko_file_viewer,
  FileUploader: ko_FileUploader,
  infobar: ko_infobar,
  LandingPage: ko_LandingPage,
  'main-topbar': ko_main_topbar,
  measurement: ko_measurement,
  'media-manager': ko_media_manager,
  notification: ko_notification,
  observations: ko_observations,
  search: ko_search,
  sidebar: ko_sidebar,
  template: ko_template,
  ThreeD: ko_ThreeD,
  timeseries: ko_timeseries,
  trends: ko_trends,
  'user-onboarding': ko_user_onboarding,
  user: ko_user,
};

const lvFilesByNamespace: NamespaceMap = {
  activity: lv_activity,
  asset: lv_asset,
  assignment: lv_assignment,
  checklist: lv_checklist,
  conditions: lv_conditions,
  configuration: lv_configuration,
  documents: lv_documents,
  ErrorView: lv_ErrorView,
  'file-viewer': lv_file_viewer,
  FileUploader: lv_FileUploader,
  infobar: lv_infobar,
  LandingPage: lv_LandingPage,
  'main-topbar': lv_main_topbar,
  measurement: lv_measurement,
  'media-manager': lv_media_manager,
  notification: lv_notification,
  observations: lv_observations,
  search: lv_search,
  sidebar: lv_sidebar,
  template: lv_template,
  ThreeD: lv_ThreeD,
  timeseries: lv_timeseries,
  trends: lv_trends,
  'user-onboarding': lv_user_onboarding,
  user: lv_user,
};

const nbFilesByNamespace: NamespaceMap = {
  activity: nb_activity,
  asset: nb_asset,
  assignment: nb_assignment,
  checklist: nb_checklist,
  conditions: nb_conditions,
  configuration: nb_configuration,
  documents: nb_documents,
  ErrorView: nb_ErrorView,
  'file-viewer': nb_file_viewer,
  FileUploader: nb_FileUploader,
  infobar: nb_infobar,
  LandingPage: nb_LandingPage,
  'main-topbar': nb_main_topbar,
  measurement: nb_measurement,
  'media-manager': nb_media_manager,
  notification: nb_notification,
  observations: nb_observations,
  search: nb_search,
  sidebar: nb_sidebar,
  template: nb_template,
  ThreeD: nb_ThreeD,
  timeseries: nb_timeseries,
  trends: nb_trends,
  'user-onboarding': nb_user_onboarding,
  user: nb_user,
};

const nlFilesByNamespace: NamespaceMap = {
  activity: nl_activity,
  asset: nl_asset,
  assignment: nl_assignment,
  checklist: nl_checklist,
  conditions: nl_conditions,
  configuration: nl_configuration,
  documents: nl_documents,
  ErrorView: nl_ErrorView,
  'file-viewer': nl_file_viewer,
  FileUploader: nl_FileUploader,
  infobar: nl_infobar,
  LandingPage: nl_LandingPage,
  'main-topbar': nl_main_topbar,
  measurement: nl_measurement,
  'media-manager': nl_media_manager,
  notification: nl_notification,
  observations: nl_observations,
  search: nl_search,
  sidebar: nl_sidebar,
  template: nl_template,
  ThreeD: nl_ThreeD,
  timeseries: nl_timeseries,
  trends: nl_trends,
  'user-onboarding': nl_user_onboarding,
  user: nl_user,
};

const ptFilesByNamespace: NamespaceMap = {
  activity: pt_activity,
  asset: pt_asset,
  assignment: pt_assignment,
  checklist: pt_checklist,
  conditions: pt_conditions,
  configuration: pt_configuration,
  documents: pt_documents,
  ErrorView: pt_ErrorView,
  'file-viewer': pt_file_viewer,
  FileUploader: pt_FileUploader,
  infobar: pt_infobar,
  LandingPage: pt_LandingPage,
  'main-topbar': pt_main_topbar,
  measurement: pt_measurement,
  'media-manager': pt_media_manager,
  notification: pt_notification,
  observations: pt_observations,
  search: pt_search,
  sidebar: pt_sidebar,
  template: pt_template,
  ThreeD: pt_ThreeD,
  timeseries: pt_timeseries,
  trends: pt_trends,
  'user-onboarding': pt_user_onboarding,
  user: pt_user,
};

const svFilesByNamespace: NamespaceMap = {
  activity: sv_activity,
  asset: sv_asset,
  assignment: sv_assignment,
  checklist: sv_checklist,
  conditions: sv_conditions,
  configuration: sv_configuration,
  documents: sv_documents,
  ErrorView: sv_ErrorView,
  'file-viewer': sv_file_viewer,
  FileUploader: sv_FileUploader,
  infobar: sv_infobar,
  LandingPage: sv_LandingPage,
  'main-topbar': sv_main_topbar,
  measurement: sv_measurement,
  'media-manager': sv_media_manager,
  notification: sv_notification,
  observations: sv_observations,
  search: sv_search,
  sidebar: sv_sidebar,
  template: sv_template,
  ThreeD: sv_ThreeD,
  timeseries: sv_timeseries,
  trends: sv_trends,
  'user-onboarding': sv_user_onboarding,
  user: sv_user,
};

const zhFilesByNamespace: NamespaceMap = {
  activity: zh_activity,
  asset: zh_asset,
  assignment: zh_assignment,
  checklist: zh_checklist,
  conditions: zh_conditions,
  configuration: zh_configuration,
  documents: zh_documents,
  ErrorView: zh_ErrorView,
  'file-viewer': zh_file_viewer,
  FileUploader: zh_FileUploader,
  infobar: zh_infobar,
  LandingPage: zh_LandingPage,
  'main-topbar': zh_main_topbar,
  measurement: zh_measurement,
  'media-manager': zh_media_manager,
  notification: zh_notification,
  observations: zh_observations,
  search: zh_search,
  sidebar: zh_sidebar,
  template: zh_template,
  ThreeD: zh_ThreeD,
  timeseries: zh_timeseries,
  trends: zh_trends,
  'user-onboarding': zh_user_onboarding,
  user: zh_user,
};

export const translations: Resource = {
  de: deFilesByNamespace,
  en: enFilesByNamespace,
  es: esFilesByNamespace,
  fr: frFilesByNamespace,
  it: itFilesByNamespace,
  ja: jaFilesByNamespace,
  ko: koFilesByNamespace,
  lv: lvFilesByNamespace,
  nb: nbFilesByNamespace,
  nl: nlFilesByNamespace,
  pt: ptFilesByNamespace,
  sv: svFilesByNamespace,
  zh: zhFilesByNamespace,
};
